module.exports = __webpack_public_path__ + "static/favicon.7fe0ad91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon.png
// module id = 1247
// module chunks = 114276838955818